import { AnimatePresence } from 'framer-motion';
import { Control, useWatch } from 'react-hook-form';
import { z } from 'zod';

import { AdditionalFormProps } from '@ui-furniture/common/contact-details-form';
import { Checkbox, Input } from '@ui-furniture/common/form';
import { Row, Text, VStack } from '@ui-furniture/elements';
import { zod } from '@ui-furniture/lib/utils/zod-validation';
import { SoloAnimation } from '@ui-furniture/ui/animation/solo';

const accessDetailsSchema = z.object({
  access: z
    .object({
      isSameAsContactDetails: z.boolean(),
      accessName: z.string().optional(),
      accessPhoneNumber: zod.phone({
        isOptional: true,
      }),
    })
    .superRefine(
      ({ isSameAsContactDetails, accessName, accessPhoneNumber }, ctx) => {
        if (!isSameAsContactDetails) {
          if (!accessName || accessName.length < 3) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              message: 'Name is required',
              path: ['accessName'],
            });
          }
          if (!accessPhoneNumber) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              message: 'Phone number is required',
              path: ['accessPhoneNumber'],
            });
          }
        }
      }
    ),
});

const AccessForm = ({ control }: { control: Control<any> }) => {
  const isSameAsContactDetails = useWatch({
    control,
    name: 'access.isSameAsContactDetails',
  });

  return (
    <>
      <Row mt='lg'>
        <Checkbox
          name='access.isSameAsContactDetails'
          label='I can provide access to the property'
        />
      </Row>
      <AnimatePresence>
        {!isSameAsContactDetails ? (
          <SoloAnimation animation='collapse'>
            <VStack>
              <Text
              // variant='bodySmall'
              // color='palette-primary'
              // fontWeight='600'
              >
                The following can provide access:
              </Text>
              <Input
                name='access.accessName'
                label='Person/Company Name'
                type='text'
              />
              <Input
                name='access.accessPhoneNumber'
                label='Phone Number'
                type='phone'
              />
            </VStack>
          </SoloAnimation>
        ) : null}
      </AnimatePresence>
    </>
  );
};

export type AccessDetails =
  | {
      isSameAsContactDetails: false;
      accessName: string;
      accessPhoneNumber: string;
    }
  | {
      isSameAsContactDetails: true;
    };
export const accessFormDetails: AdditionalFormProps<
  typeof accessDetailsSchema
> = {
  formFields: AccessForm,
  schema: accessDetailsSchema,
  defaultFields: {
    access: {
      isSameAsContactDetails: false,
    },
  },
};
